/** Builder section types of the `bikini2026` templates. No imports: `entities/LandingPage` reads it. */
export const bikini2026SectionTypes = [
  // "6 Tygodni do Bikini" 2026 landing
  "bikini2026Header",
  "bikini2026Hero",
  "bikini2026Transformations",
  "bikini2026Pain",
  "bikini2026Included",
  "bikini2026Timeline",
  "bikini2026Reward",
  "bikini2026Metamorphoses",
  "bikini2026Offer",
  "bikini2026Faq",
  "bikini2026Footer",
  "bikini2026StickyCta",
  // its Hollywood-style checkout
  "bikini2026Checkout",
  // checkout and thank-you of the classic Bikini funnel
  "bikiniFunnelCheckout",
  "bikiniFunnelThankYou",
] as const;
